import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'app',
  components: {
    Loading
  },
  data () {
    return {}
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.state.screenWidth = window.innerWidth
      this.$store.state.screenHeight = window.innerHeight
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/app.js